import { Injectable } from '@angular/core';
import { ServiceBase } from '../service.base';
import { HttpClient } from '@angular/common/http';
import { AuthService, ResponseObject } from '../auth.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Templates } from 'src/app/models/emailevents.model';

@Injectable({
  providedIn: 'root'
})
export class SystemEventsWorkflowService extends ServiceBase {
  private api = '/SystemEventsWorkflow';

  constructor(private http: HttpClient, authService: AuthService) {
    super(authService);
  }

  public fetchEvents(): Observable<SystemEvent[]> {
    const httpOptions = this.RequestHeaders();
    const url = `${environment.BASE_API_PATH}${this.api}/fetch-workflow-events`;
    return this.http.get<SystemEvent[]>(url, httpOptions);
  }

  public fetchEventActionTypes(systemEventId: string): Observable<SystemEvent[]> {
    const httpOptions = this.RequestHeaders();
    const url = `${environment.BASE_API_PATH}${this.api}/fetch-workflow-event-actiontypes/${systemEventId}`;
    return this.http.get<SystemEvent[]>(url, httpOptions);
  }

  public fetchWorkflowEventsTriggered(): Observable<WorkflowEventTriggered[]> {
    const httpOptions = this.RequestHeaders();
    const url = `${environment.BASE_API_PATH}${this.api}/fetch-workflow-events-triggered`;
    return this.http.get<WorkflowEventTriggered[]>(url, httpOptions);
  }

  public fetchAllTemplates(): Observable<Templates[]> {
    const url: string = `${environment.BASE_API_PATH}/EmailTemplates/fetch-templates`;
    return this.http.get<Templates[]>(url, this.RequestHeaders());
  }

  public updateTriggerEventAction(updateTriggerEventActionRequest: UpdateTriggerEventActionRequest): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const url = `${environment.BASE_API_PATH}${this.api}/update-trigger-event-action`;
    return this.http.post<ResponseObject>(url, updateTriggerEventActionRequest, httpOptions);
  }

  public updateIsTriggerEventAction(requestData: { id: string, isTrigger: boolean }): Observable<ResponseObject> {
    const httpOptions = this.RequestHeaders();
    const url = `${environment.BASE_API_PATH}${this.api}/update-is-trigger-event-action`;
    return this.http.put<ResponseObject>(url, requestData, httpOptions);
  }
}

export interface SystemEvent {
  label: string;
  value: string;
  data: string;
}

export interface WorkflowEventTriggered {
  Id: string;
  SystemEventId: string;
  SystemEvent: string;
  SystemEventDescription: string;
  SystemEventTriggeredActionDtos: SystemEventTriggeredActionDto[];
}

export interface EmailEventViewModel {
  Guid: string;
  HtmlText: string;
  EmailEventId: string;
  Subject: string;
}

export interface UpdateTriggerEventActionRequest {
  Id: string;
  systemEventId: string;
  systemEventActionTypeId: string;
  emailTemplateId: string;
  smsTemplateId: string;
  apiEndpoint: string;
  apiHttpMethod: string;
  apiHeaders: string;
  apiRequestBodyTemplate: string;
  userId: string;
  createdDate?: string;
  ModifiedDate: string;
  apiName: string;
  isTrigger: boolean;
}

export interface SystemEventActionEmailTemplateDto {
  EmailEventId: string | null;
  EmailEventName: string | null;
  EmailEventDescription: string | null;
  IsPredefined: boolean;
  EmailTemplateId: string | null;
  EmailTemplateHtmlText: string | null;
  EmailTemplateSubject: string | null;
  IsSendToBccEmail: boolean;
}

export interface SystemEventActionApiCallDto {
  ApiName: string | null;
  ApiEndpoint: string | null;
  ApiHttpMethod: string | null;
  ApiHeaders: string | null;
  ApiRequestBodyTemplate: string | null;
}

export interface SystemEventActionSmsTemplateDto {
  Id: string | null;
  SystemEventId: string | null;
  Text: string | null;
  CreatedDate: string | null;
  ModifiedDate: string | null;
  EventTypeViewModel: {
    Id: string | null;
    Name: string | null;
    Description: string | null;
    IsPredefined: boolean;
    IsEmailEvent: boolean;
    CreatedDate: string | null;
    EmailParameterIds: string[] | null;
  };
}

export interface SystemEventTriggeredActionDto {
  Id: string;
  SystemEventId: string;
  SystemEventActionTypeId: string;
  SystemEventActionType: string;
  IsTrigger: boolean;
  SystemEventActionEmailTemplateDto?: SystemEventActionEmailTemplateDto;
  SystemEventActionApiCallDto?: SystemEventActionApiCallDto;
  SmsTemplateDto?: SystemEventActionSmsTemplateDto;
  CreatedDate: string;
  ModifiedDate: string;
}

export enum SystemEventActionTypeEnum {
  Email = "Email",
  ApiCall = "Api Call",
  SMS = "Sms"
}